/* eslint-disable no-loop-func */
import { useEffect, useRef, useState } from "react";
import worker_script from "../worker";
import { useAppDispatch, useAppSelector } from "../store/storeRequests";
import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import { showMessageOnFailure } from "../store/error.actions";
import { getDetails } from "../services/http/http.service";
import store from "../store/store";
import { setUser } from "../store/authentication/authentication.slice";
import StoreSelectors from "../utils/constants/StoreSelectors.constants";
import APIList from "../utils/constants/APIList";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "scroll",
  "keypress",
  "click",
];

const useIdleTimout = () => {
  const isWorkerInitialized = useRef(false);
  const user = useAppSelector(StoreSelectors.USER_STATE);
  const currentUser = useAuth();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [worker, setWorker] = useState<Worker | null>(null);

  useEffect(() => {
    if (isWorkerInitialized.current) {
      if (worker !== null) {
        worker?.terminate();
      } else {
        setWorker(new Worker(worker_script));
      }
      return;
    }
    if (currentUser === 1) {
      if (worker === null) {
        setWorker(new Worker(worker_script));
      }
      if (worker !== null) {
        worker.postMessage("start");
      }
    }
  }, [currentUser, user, worker]);

  if (worker === null) {
    return null;
  }

  worker.onmessage = async (ev) => {
    if (ev.data === "expired") {
      await getDetails(APIList.ADMIN_LOGOUT)
      localStorage.clear();
      sessionStorage.clear();
      navigate("/admin/login");
      dispatch(showMessageOnFailure("Session expired. Please login again..."));
      // store.dispatch(
      //   setUser({
      //     user_id: "",
      //     roleName: "",
      //     email: "",
      //     token: "",
      //     isNewUser: false,
      //   })
      // );
    }

    if (ev.data === "initialized") {
      for (let i in events) {
        document.addEventListener(events[i], () => {
          if (worker !== null) worker.postMessage("reset");
        });
      }
      isWorkerInitialized.current = true;
    }

    if (ev.data === "terminated") {
      isWorkerInitialized.current = false;
      navigate("/admin/login");
      for (let i in events) {
        document.removeEventListener(events[i], () => {
          if (worker !== null) worker.postMessage("terminate");
        });
      }
      if (worker !== null) worker.terminate();
      setWorker(null);
    }
  };

  return worker;
};

export default useIdleTimout;
